import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../../_common/components/Footer/Footer";

export const UsersFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.users.totalCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};
